import React, {Component} from "react";

class MobileRecording extends Component {
    constructor(props) {
        super();
    }

    onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {
                const {
                    currentRecordingFlowChart,
                    recordData,
                    setRecordData
                } = this.props;
                let newRecordData = {...recordData};
                switch (rowInfo.row._original.id) {
                    case "clear":
                        newRecordData.fields[currentRecordingFlowChart.tableField] = "";
                        break;
                    case "backspace":
                        const length =
                            newRecordData.fields[currentRecordingFlowChart.tableField].length;
                        if (length > 0) {
                            newRecordData.fields[
                                currentRecordingFlowChart.tableField
                                ] = newRecordData.fields[
                                currentRecordingFlowChart.tableField
                                ].substring(0, length - 1);
                        }
                        break;
                    default:
                        newRecordData.fields[currentRecordingFlowChart.tableField] +=
                            rowInfo.row._original.text;
                }
                newRecordData.fields[`${currentRecordingFlowChart.tableField}Display`] =
                    newRecordData.fields[currentRecordingFlowChart.tableField];

                setRecordData(newRecordData);
            }
        };
    };

    onFieldContinue = async () => { //async
        const {
            currentFlowChart,
            currentRecordingFlowChart,
            getNextRecordingFlowChart,
            setCurrentRecordingFlowChart
        } = this.props;
        // console.log("TODO-1a: getNextRecordingFlowChart", currentRecordingFlowChart)
        const newCurrentRecordingFlowChart = await getNextRecordingFlowChart(
            currentFlowChart,
            currentRecordingFlowChart
        );
        // console.log("TODO-1b: getNextRecordingFlowChart", newCurrentRecordingFlowChart)
        // diese Zeilen muessen auskommentiert werden, denn ansonsten funktoniert goto nicht!
        // if (
        //   newCurrentRecordingFlowChart === null ||
        //   newCurrentRecordingFlowChart === undefined
        // ) {
        //   pushNewMenu({
        //     level: [],
        //     flowChart: flowChart,
        //   });
        // }

        if (newCurrentRecordingFlowChart !== null) {
            // die Abfrage auf null ist bei folgender Abfolge notwendig
            // Speichern bei mobileRecordingShowOverview
            // ... denn ansonsten würde currentRecordingFlowChart 2x gesetzt werden
            // ... und für die render-Methode würde currentRecordingFlowChart den falschen Wert haben
            // ... dies ist vor allem dann der Fall, wenn im Ablauf eine Endlos-Schleife absichtlich hinterlegt ist
            // ... z.B. beim Ersatz eines Barcodescanners
            setCurrentRecordingFlowChart(newCurrentRecordingFlowChart);
            // TODO: push
        }
    };

    onFieldCancel = () => {
        const {pushNewMenu, flowChart, currentFlowChart} = this.props;

        let newLevel = [];
        if (currentFlowChart && currentFlowChart.cancelLevel) {
            newLevel = [...currentFlowChart.cancelLevel];
        }
        // this.pushNewMenu({
        //   level: newLevel,
        //   flowChart: { ...flowChart }
        // });

        pushNewMenu({
            level: newLevel,
            flowChart: flowChart
        });
    };

    onChange = id => {
        const {currentRecordingFlowChart, recordData, setRecordData} = this.props;
        let newRecordData = {...recordData};
        newRecordData.fields = {...recordData.fields}; // ?????????
        switch (id.toUpperCase()) {
            case "ESCAPE":
            case "CLEAR":
            case "CLR":
                newRecordData.fields[currentRecordingFlowChart.tableField] = "";
                break;
            case "BACKSPACE":
            case "BS":
                const length =
                    newRecordData.fields[currentRecordingFlowChart.tableField].length;
                if (length > 0) {
                    newRecordData.fields[
                        currentRecordingFlowChart.tableField
                        ] = newRecordData.fields[
                        currentRecordingFlowChart.tableField
                        ].substring(0, length - 1);
                }
                break;
            default:
                newRecordData.fields[currentRecordingFlowChart.tableField] += id;

                if (
                    currentRecordingFlowChart.maxSize &&
                    newRecordData.fields[currentRecordingFlowChart.tableField].length >
                    currentRecordingFlowChart.maxSize
                ) {
                    return;
                }
        }
        newRecordData.fields[`${currentRecordingFlowChart.tableField}Display`] =
            newRecordData.fields[currentRecordingFlowChart.tableField];

        setRecordData(newRecordData);
    };

    onHtmlInputChange = (input, displayInput) => {
        const {currentRecordingFlowChart, recordData, setRecordData} = this.props;
        let newRecordData = {...recordData};
        newRecordData.fields = {...recordData.fields}; // ?????????
        newRecordData.fields[currentRecordingFlowChart.tableField] = input;
        newRecordData.fields[
            `${currentRecordingFlowChart.tableField}Display`
            ] = displayInput;

        if (
            currentRecordingFlowChart.maxSize &&
            newRecordData.fields[currentRecordingFlowChart.tableField].length >
            currentRecordingFlowChart.maxSize
        ) {
            return;
        }

        setRecordData(newRecordData);
    };

    isValidRegExp(currentRecordingFlowChart, recordData) {
        if (
            currentRecordingFlowChart.regexp &&
            currentRecordingFlowChart.regexp.muster
        ) {
            let regExp = null;
            if (currentRecordingFlowChart.regexp.flags) {
                regExp = new RegExp(
                    currentRecordingFlowChart.regexp.muster,
                    currentRecordingFlowChart.regexp.flags
                );
            } else {
                regExp = new RegExp(currentRecordingFlowChart.regexp.muster);
            }

            if (
                regExp.test(recordData.fields[currentRecordingFlowChart.tableField])
            ) {
                return true;
            } else {
                return false;
            }
        }

        return true;
    }

    isSelectionDisabled(currentRecordingFlowChart, recordData) {
        if (
            currentRecordingFlowChart &&
            (!currentRecordingFlowChart.maxSize ||
                recordData.fields[currentRecordingFlowChart.tableField].length <
                currentRecordingFlowChart.maxSize)
        ) {
            return false;
        }
        return true;
    }

    isContinueButtonDisabled(currentRecordingFlowChart, recordData) {
        if (!currentRecordingFlowChart || !currentRecordingFlowChart.minSize)
            return false;

        if (
            recordData.fields[currentRecordingFlowChart.tableField].length >=
            currentRecordingFlowChart.minSize
        ) {
            if (this.isValidRegExp(currentRecordingFlowChart, recordData)) {
                return false;
            }
        }
        return true;
    }

    render = () => {
        return <React.Fragment></React.Fragment>;
    }
}

export default MobileRecording;
